import { cancellationThunksFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.thunks';

export const cpOrderCancellationThunks = cancellationThunksFactory('CP_ORDER');
